import type { DeployEnvironment } from "@enrein/shared-contracts/deploy-env";
import { normalizeDeployEnvironment } from "@enrein/shared-contracts/deploy-env";

export interface ClientPortalRuntimeConfig {
  readonly apiBaseUrl: string;
  readonly deployEnv: DeployEnvironment;
  readonly portalUiVariant: ClientPortalUiVariant;
}

export type ClientPortalUiVariant = "legacy" | "guided" | "v10" | "greenfield";

interface ClientPortalImportMetaEnv {
  readonly VITE_ENREIN_CLIENT_PORTAL_API_BASE_URL?: string;
  readonly VITE_ENREIN_DEPLOY_ENV?: string;
  readonly VITE_ENREIN_CLIENT_PORTAL_UI?: string;
}

function env(): ClientPortalImportMetaEnv {
  return import.meta.env as ClientPortalImportMetaEnv;
}

export function readClientPortalRuntimeConfig(): ClientPortalRuntimeConfig {
  const e = env();
  const portalUiRaw = (e.VITE_ENREIN_CLIENT_PORTAL_UI ?? "greenfield").trim().toLowerCase();
  const portalUiVariant: ClientPortalUiVariant =
    portalUiRaw === "legacy"
      ? "legacy"
      : portalUiRaw === "guided"
        ? "guided"
        : portalUiRaw === "v10"
          ? "v10"
          : "greenfield";
  return {
    apiBaseUrl: (e.VITE_ENREIN_CLIENT_PORTAL_API_BASE_URL ?? "http://localhost:3000").replace(/\/$/, ""),
    deployEnv: normalizeDeployEnvironment(e.VITE_ENREIN_DEPLOY_ENV),
    portalUiVariant,
  };
}
